var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.5H2H1.5V16V9V8.5H2H5.22288L5.84788 7.5H2H1.5V7V2V1.5H2H8H8.5V2V7V7.5H8H6V8.5H8H8.5V9V16V16.5H8H4.77712L4.15212 17.5H9.5V10.5V10H10H11.251H11.255V10C11.4127 10.0013 11.6244 10.0413 11.7926 10.2094C11.9614 10.3783 12.001 10.5909 12.001 10.75V15.375C12.001 15.9356 12.2023 16.424 12.6325 16.8614C13.0581 17.2942 13.5476 17.5 14.126 17.5H14.1265C14.7231 17.5005 15.2135 17.293 15.6278 16.8652C16.0506 16.4285 16.25 15.9389 16.25 15.375V6V5.5H16.75H17H17.0012C17.1569 5.50037 17.2647 5.45317 17.3584 5.35945C17.4522 5.26566 17.5 5.15715 17.5 5V3.5H17H16.5H15.5H15H14.5L14.5 4.99882C14.5 4.99894 14.5 4.99907 14.5 4.99919C14.5004 5.15605 14.5484 5.26493 14.6422 5.35906C14.7351 5.45227 14.8429 5.5 15 5.5H15.25H15.75V6L15.75 15.3738C15.75 15.374 15.75 15.3741 15.75 15.3743V15.375H15.25C15.2507 15.6583 15.1383 15.9167 14.913 16.15C14.6877 16.3833 14.425 16.5 14.125 16.5C13.8417 16.5 13.5833 16.3833 13.35 16.15C13.1167 15.9167 13 15.6583 13 15.375L4 16.5ZM4 16.5V17.5H0.5M4 16.5L0.5 17.5M0.5 17.5V2C0.5 1.58381 0.642455 1.24014 0.941252 0.941854C1.24047 0.64315 1.5846 0.500568 2.00033 0.5L0.5 17.5ZM5 12.5V13V14.2566L6.09788 12.5H5.5H5ZM5 12.5V12V10.7434L3.90212 12.5H4.5H5Z",
    stroke: "#00A22D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fa9e8d7c94c8663ae3e46ff091d7d10a.svg";
export { ForwardRef as ReactComponent };